import { AnyAction } from 'redux'
import { Guest } from '../../axios/pms/guests/types'
import {
	SET_ROOM_CHARGE_ERROR_CODE,
	SET_ROOM_CHARGE_GUESTS,
	SET_ROOM_CHARGE_GUESTS_ARE_LOADING,
	SET_ROOM_CHARGE_IS_PROCESSING,
	SET_ROOM_CHARGE_ORDER_ID,
} from '../../actionTypes/roomCharge'

export interface RoomChargeState {
	orderId: string | null
	guests: Guest[]
	guestsAreLoading: boolean
	isProcessing: boolean
	errorCode: string | null
}

const initialState: RoomChargeState = {
	orderId: null,
	guests: [],
	guestsAreLoading: false,
	isProcessing: false,
	errorCode: null,
}

export function roomChargeReducer (state = initialState, action: AnyAction): RoomChargeState {
	switch (action.type) {
		case SET_ROOM_CHARGE_ORDER_ID:
			return { ...state, orderId: action.value }
		case SET_ROOM_CHARGE_GUESTS:
			return { ...state, guests: action.value }
		case SET_ROOM_CHARGE_GUESTS_ARE_LOADING:
			return { ...state, guestsAreLoading: action.value }
		case SET_ROOM_CHARGE_IS_PROCESSING:
			return { ...state, isProcessing: action.value }
		case SET_ROOM_CHARGE_ERROR_CODE:
			return { ...state, errorCode: action.value }
		default:
			return state
	}
}
